module.exports = __webpack_public_path__ + "img/game-medium-white-logo-with-gradient-background.e1b70284.png";